export const EQUIPMENT_DETAILS_QUERY_KEY = "equipment-details";
export const PORTFOLIO_EQUIPMENT_QUERY_KEY = "portfolio-equipment";
export const SITE_EQUIPMENT_QUERY_KEY = "site-equipment";
export const SITE_EQUIPMENT_PAGE_QUERY_KEY = "site-equipment-page";
